package br.com.vvrefeicoes.portal.domain.model

data class MonthCount(
    val period: MonthPeriod,
    val count: Int,
)

data class CountItem(
    val label: String,
    val count: Int,
)

data class ComplaintsSnapshot(
    val periodLabel: String,
    val months: List<MonthPeriod>,
    val total: Int,
    val byStatus: Map<String, Int>,
    val evolution: List<MonthCount>,
    val byShift: List<CountItem>,
    val byService: List<CountItem>,
    val byNature: List<CountItem>,
    val byUnit: List<CountItem>,
    val records: List<CustomerComplaint>,
) {
    companion object {
        val Empty =
            ComplaintsSnapshot(
                periodLabel = "",
                months = emptyList(),
                total = 0,
                byStatus = emptyMap(),
                evolution = emptyList(),
                byShift = emptyList(),
                byService = emptyList(),
                byNature = emptyList(),
                byUnit = emptyList(),
                records = emptyList(),
            )
    }
}
